/**
 * API key management hooks — back the admin "API keys" page.
 */
import { useCCMS } from '../useCCMS';
export function useApiKeysServices() {
    const { services } = useCCMS();
    if (!services?.apiKeys)
        throw new Error('API key services not available. Ensure CCMSProvider is configured with apiKeys services.');
    return services.apiKeys;
}
export function useApiKeysService() {
    return useApiKeysServices().apiKeys;
}
//# sourceMappingURL=useApiKeysServices.js.map